/* TOFL Theme — global behavior */
(function(){
  'use strict';

  // Year stamp
  var yr = document.getElementById('yr');
  if (yr) yr.textContent = new Date().getFullYear();

  // Sticky nav scroll behavior
  var nav = document.getElementById('tofl-nav');
  if (nav) {
    var isIndex = document.body.classList.contains('template-index');
    var onScroll = function(){
      if (window.scrollY > 60 || !isIndex){
        nav.classList.add('scrolled');
        nav.classList.remove('atop');
      } else {
        nav.classList.remove('scrolled');
        nav.classList.add('atop');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reveal-on-scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.remove('fade-prep');
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(function(el){
      var r = el.getBoundingClientRect();
      var inView = r.top < window.innerHeight && r.bottom > 0;
      if (!inView){
        el.classList.add('fade-prep');
        io.observe(el);
      } else {
        el.classList.add('in');
      }
    });
  }

  // Smooth-scroll for in-page anchors
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if (id && id.length > 1 && id.charAt(0) === '#'){
        var t = document.querySelector(id);
        if (t){ e.preventDefault(); t.scrollIntoView({ behavior:'smooth', block:'start' }); }
      }
    });
  });

  // FAQ accordion + category filter
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      if (item) item.classList.toggle('open');
    });
  });
  var cats = document.querySelectorAll('.faq-cat');
  if (cats.length){
    cats.forEach(function(c){
      c.addEventListener('click', function(){
        var filter = c.getAttribute('data-cat');
        cats.forEach(function(x){ x.classList.remove('active'); });
        c.classList.add('active');
        document.querySelectorAll('.faq-item').forEach(function(item){
          if (filter === 'all' || item.getAttribute('data-cat') === filter){
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  }

  // Product page — gallery thumb swap
  document.querySelectorAll('[data-gallery]').forEach(function(gallery){
    var featured = gallery.querySelector('.featured-img img');
    gallery.querySelectorAll('.thumbs img').forEach(function(t){
      t.addEventListener('click', function(){
        if (featured) featured.src = t.getAttribute('data-full') || t.src;
        gallery.querySelectorAll('.thumbs img').forEach(function(x){ x.classList.remove('active-thumb'); });
        t.classList.add('active-thumb');
      });
    });
  });

  // Product page — variant selector: image swap, price update, availability
  (function(){
    var jsonEl = document.getElementById('product-variants-json');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch(e) { return; }
    var selects        = document.querySelectorAll('.variant-option');
    var featuredImg    = document.getElementById('featured-image');
    var variantIdInput = document.getElementById('variant-id');
    var priceEl        = document.getElementById('product-price');
    var addBtn         = document.getElementById('add-to-cart-btn');
    function formatMoney(cents){
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function getSelectedOptions(){
      var opts = [];
      selects.forEach(function(s){ opts.push(s.value); });
      return opts;
    }
    function findVariant(opts){
      return variants.find(function(v){
        var match = true;
        if (opts[0] !== undefined && v.option1 !== null && v.option1 !== opts[0]) match = false;
        if (opts[1] !== undefined && v.option2 !== null && v.option2 !== opts[1]) match = false;
        if (opts[2] !== undefined && v.option3 !== null && v.option3 !== opts[2]) match = false;
        return match;
      });
    }
    function updateProduct(){
      var opts    = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      if (addBtn){
        if (variant.available){
          addBtn.disabled = false;
          addBtn.textContent = 'Add To Cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        }
      }
      if (variant.featured_image && featuredImg){
        featuredImg.src = variant.featured_image.src;
        featuredImg.alt = variant.featured_image.alt || '';
        document.querySelectorAll('[data-gallery] .thumbs img').forEach(function(t){
          t.classList.remove('active-thumb');
          if (t.getAttribute('data-image-id') === String(variant.featured_image.id)){
            t.classList.add('active-thumb');
          }
        });
      }
    }
    selects.forEach(function(s){ s.addEventListener('change', updateProduct); });
    updateProduct();
  })();

})();